import { render } from "./CookieCloud.vue?vue&type=template&id=2532c9fd&scoped=true"
import script from "./CookieCloud.vue?vue&type=script&lang=js"
export * from "./CookieCloud.vue?vue&type=script&lang=js"

import "./CookieCloud.vue?vue&type=style&index=0&id=2532c9fd&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2532c9fd"]])

export default __exports__